module.exports = "/complete_verification-eabe6030c2869fb80cbec5c07c7b0e93.svg";